const origin = window.location.origin;
const originMap = {
  'https://newsela.com': 'https://beta.newsela.com',
  'https://staging.newseladev.com': 'https://beta.staging.newseladev.com',
  'http://localhost:8000': 'http://localhost:5923',
  'https://localhost': 'http://localhost:5923',
};
export const lyceumOrigin = originMap[origin] || 'https://beta.newsela.com';
